// components/Contact/ContactCTA.jsx
import React from "react";
import { motion } from "framer-motion";
import MKTypography from "components/MKTypography";

export default function ContactCTA() {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <MKTypography variant="h2" fontWeight="bold" color="info.main" mb={2}>
          Contact Us
        </MKTypography>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
      >
        <MKTypography variant="body1" color="text" maxWidth={700} textAlign="center">
          Have a question, project idea, or just want to connect? We&apos;re here to help.
        </MKTypography>
      </motion.div>
    </>
  );
}
